/* eslint-disable */
import { api } from './../../api.js';

const state = {
};

const getters = {

}

const mutations = {
}

const actions = {
    getLastOrder: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('orders/last', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getTipoDocumentOrder: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('orders/' + data.order_id + '/document/' + data.document_id + '/tipo', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    sendOrderToClient: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('orders/' + data.id + '/send', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    unconfirmOrder: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('orders/' + data.order_id + '/unconfirm', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    confirmOrder: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('orders/' + data.id + '/confirm', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    deleteFolder: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.delete('orders/' + data.order_id + '/folder/' + data.folder_id, data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    renameFolder: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.patch('orders/' + data.order_id + '/folder/' + data.folder_id, data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    createFolder: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('orders/' + data.order_id + '/folder/' + data.folder_id, data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getDirectories: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('orders/' + data.order_id + '/directories', {}).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    deleteDocumentConfirmation: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.delete('orders/' + data.order_id + '/pdf/' + data.documento_id, {}).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getOrderDocumentsConfirmation: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('orders/' + data.order_id + '/pdf', {}).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    copyOrder: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('orders/' + data.id + '/copy', {}).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    updateStatusOrders: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.patch('orders/' + data.id + '/status', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    orderConfirmation: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('orders/' + data.id + '/confirmation', {}).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    updateOrder: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.patch('orders/' + data.id, data.data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    updateOrderLine: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.patch('orders/' + data.order_id + '/products/' + data.order_line_id, data.data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getOrderLine: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('orders/' + data.order_id + '/products/' + data.order_line_id, data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    createOrderLine: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('orders/' + data.id + '/products', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    deleteOrderLine: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.delete('orders/' + data.order_id + '/products/' + data.order_line_id, data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getProducts: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('orders/products', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    saveAdditionalText: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.patch('orders/' + data.id + '/text', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getOrderDetail : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('orders/' + data.id, {}).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getLogs : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('orders/' + data.order_id + '/logs', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getOrders : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('orders', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    deleteOrder : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.delete('orders/' + data.id, data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    createOrder: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('orders', data.data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },

    /* ORDER TRANSPORT */
    getOrderTransports : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('orders/' + data.id + '/transports', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },

    createOrderTransport : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('orders/' + data.id + '/transports', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },

    editOrderTransport : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.patch('orders/' + data.id + '/transports/' + data.transport_id, data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },

    deleteOrderTransport : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.delete('orders/' + data.id + '/transports/' + data.transport_id, data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },

    orderFolderFinish : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('orders/' + data.id + '/folder/uploaded', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
}

export default {
    state,
    actions,
    getters,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/OrdersModule.js